<template>
  <div class="modal-header">
    <div class="container px-0">
      <div class="modal-title">
        Informazioni
      </div>
      <button type="button" class="close" data-dismiss="modal">
        <div class="close-span">
          CHIUDI
          <div class="icon icon-cross" aria-hidden="true"/>
        </div>
      </button>
    </div>
  </div>
  <div class="modal-body container travel-status-modal">
      <div class="col-lg-8 col-md-9 col-12 h-100 mx-auto information-box modal-centered">
        <div class="row">
          <div class="col-12 extension-title">Cosa significa lo status del mio viaggio?</div>
          <div class="row" v-html="this.assets.travelStatusModal"></div>
        </div>
      </div>
    </div>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "travelStatusModal",
    computed: {
      ...mapState([
          'assets'
      ])
    }
}
</script>